import React from "react";
import {
  FormCreationData,
  DeviceType,
} from "../../../../../stateManager/store/formCreation_v2/types";
import { Grid } from "../components/Grid";
import { ExpansionPanel } from "../components/ExpansionPanel";
import { Flex } from "../components/Flex";
import { TabBar } from "../components/TabBar";
import {Container} from "../components/container";

export const flexContainers = ['Row', 'Column']
export const gridContainers = ['Grid', 'ExpansionPanel', 'CustomModal', 'TabBar']

export const handleContainers = (props: {
  element: FormCreationData;
  deviceType: DeviceType;
  isCheckedIn?: Boolean;
  zoomScale? :any;
}) => {
  if (props.element.type === "Grid") {
    return <Grid {...props} />;
  }
  if (props.element.type === "ExpansionPanel") {
    return <ExpansionPanel {...props} />;
  }
  
  if (props.element.type === "TabBar") {
    return <TabBar {...props} />;
  }
  if(flexContainers.includes(props.element.type)){
    return <Flex {...props} />
  }
  if (props.element.type === "Container") {
    return <Container  {...props} />
  }
};
